import { render, staticRenderFns } from "./StudyAutocomplete.vue?vue&type=template&id=9faca9e0&"
import script from "./StudyAutocomplete.vue?vue&type=script&lang=js&"
export * from "./StudyAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports